import './plugins/offline';
import './plugins/vuetify';
import './plugins/axios';
import './plugins/filters';
import './plugins/vuelidate';

import Vue    from "vue";
import App    from "./App.vue";
import router from "./router/";
import store  from "./store";
import moment from "moment";

import "./registerServiceWorker";

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'font-awesome/css/font-awesome.css';

moment.locale('pt-BR');

Vue.prototype.moment = moment;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
